import { useCallback } from 'react';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { useSimpleReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleReadPattern';
import { OrganizationSecretItems } from 'libs/end-to-end/src/types/secrets/organization-secret-items';

export const useListOrganizationSecretsPattern = ({
  organizationId,
}: {
  organizationId: string;
}) => {
  const listSecretsGetUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/organizations/${organizationId}/secrets`;
  }, [organizationId]);

  return useSimpleReadPattern({
    getUrlFn: listSecretsGetUrlFn,
    responseSchema: OrganizationSecretItems,
    canRead: true,
  });
};
